import { renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "bs-dropdown-tooltip",
    style: _normalizeStyle({ position: _ctx.position, left: `${_ctx.x}px`, top: `${_ctx.y}px`, maxHeight: _ctx.maxHeight })
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 4))
}